import React from "react";

export default function BoundaryStaffingNotice({ boundary }) {
  const clock = (rawHour) => {
    const hour = ((rawHour % 24) + 24) % 24;
    return `${String(Math.floor(hour)).padStart(2, "0")}:${String(Math.round((hour % 1) * 60)).padStart(2, "0")}`;
  };
  return (

          <section role="alert" className="mb-4 rounded-lg border border-amber-300 bg-amber-50 p-4 text-sm text-amber-950">
            <p className="font-semibold">Opening/closing staffing needs review</p>
            <p>You can apply this schedule with the staffing warnings shown below.</p>
            <ul className="mt-2 list-disc pl-5">
              {(boundary?.conflicts || []).slice(0, 5).map((item, index) => (
                <li key={index}>{item.date} at {clock(item.qh_num)} — {item.department}: {item.scheduled} scheduled; required {item.maximum == null ? `at least ${item.minimum}` : `${item.minimum}–${item.maximum}`}.</li>
              ))}
              {(boundary?.role_conflicts || []).slice(0, 5).map((item, index) => (
                <li key={`role-${index}`}>{item.date} at {clock(item.qh_num)} — {item.standard}: {item.uncovered} qualified staff missing.</li>
              ))}
            </ul>
          </section>
  );
}
